export * from './pendingPatient.model';
export * from './pendingPatient.service';
export * from './pendingPatient.slice';
